import KanbanIndex from './Index'

export default [
  {
    path: '/process',
    name: 'process',
    component: KanbanIndex,
    meta: {
      auth: true,
      bodyClass: 'navbar-top',
      breadcrumb: 'Process'
    }
  }
]
